module.exports = require('./src/App');



// WEBPACK FOOTER //
// ./src/byob-cms/index.js